var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "relative",
      on: { mouseenter: _vm.showTooltip, mouseleave: _vm.hideTooltip },
    },
    [
      _vm._t("default"),
      _vm.isTooltipVisible
        ? _c(
            "div",
            { staticClass: "custom-tooltip", class: _vm.TooltipStyle },
            [_vm._t("content")],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }